import { __decorate } from "tslib";
import { ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { SharedHttp } from '../../../services/http-client.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth.service';
import { EcurrenciesService } from '../../../services/ecurrencies.service';
import { UtilityService } from '../../../services/utility.service';
import { QrScannerModalService } from '../../qr-scanner-modal/qr-scanner-modal.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { WebClientService } from '../../../services/webclient-settings.service';
import { ComponentService } from '../../../services/component.service';
import { QrScannerModalComponent } from '../../qr-scanner-modal';
import { WhitelistAddressConfirmationMailSentComponent } from "../../whitelist-address-confirmation-mail-sent/whitelist-address-confirmation-mail-sent.component";
import { ExchangeAddressConfirmationMailSentComponent } from "../../exchange-address-confirmation-mail-sent/exchange-address-confirmation-mail-sent.component";
/**
 * NewBankAccount Component
 */
let NewEAccountComponent = class NewEAccountComponent {
    constructor(httpClient, sanitizer, themeService, auth, ecurrenciesService, utilityService, qrScannerService, deviceService, changeDetector, webSettingsService, compService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.auth = auth;
        this.ecurrenciesService = ecurrenciesService;
        this.utilityService = utilityService;
        this.qrScannerService = qrScannerService;
        this.deviceService = deviceService;
        this.changeDetector = changeDetector;
        this.webSettingsService = webSettingsService;
        this.compService = compService;
        this.message = '';
        this.bankAccounts = [];
        this.cryptoAccounts = [];
        this.mainColor = '';
        this.accentColor = '';
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.inputTextColor = '';
        this.inputBackColor = '';
        this.successColor = '';
        this.user = {};
        this.loggedIn = false;
        this.ecurrencies = [];
        this.exchangeEcurrencies = [];
        this.walletEcurrencies = [];
        this.ecurrenciesError = false;
        this.validDepositAddress = true;
        this.eaccountData = {};
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.secondColor = '';
        this.accountNameEmpty = false;
        this.deviceInfo = null;
        this.isMobile = false;
        this.isTablet = false;
        this.isDesktopDevice = false;
        this.dropdownBackground = '';
        this.showSource = false;
        this.data = [];
        this.source = '';
        this.errorMessage = '';
        this.ecurrencyChains = [];
        this.showChains = false;
        this.loadCurrencies();
        this.auth.fetchUser().then(() => {
            this.user = JSON.parse(localStorage.getItem('user'));
        });
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
        });
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.dropdownBackground = this.themeService.getStyleAttribute('currency_ring_one_color');
        });
        this.qrScannerService.getScanResult().subscribe((result) => {
            if (typeof result !== 'undefined' && result !== null) {
                let arr;
                let address;
                if (result.indexOf(':') !== -1) {
                    arr = result.split(':');
                    address = arr[1];
                }
                else {
                    address = result;
                }
                if (address.indexOf('?') !== -1) {
                    arr = address.split('?');
                    address = arr[0];
                }
                this.eaccountData.deposit_address = address;
                this.validateAddress();
                this.qrScannerService.scanDone(null);
            }
        });
        this.deviceType();
    }
    ngOnInit() {
        this.source = this.data.sources[0];
    }
    loadCurrencies() {
        this.ecurrenciesService.getEcurrencies().then((data) => {
            this.exchangeEcurrencies = this.ecurrenciesService.getAllEcurrencies();
            this.ecurrencies = this.exchangeEcurrencies;
            this.numberOfEcurrencies = this.ecurrencies.length;
            this.currency = this.ecurrencies[0].code;
            this.getEcurrencyChains();
        });
        this.httpClient.get('wallet/getallcurrencies').subscribe((data) => {
            this.walletEcurrencies = data['currencies'].filter(currency => currency.fiat === false);
        });
    }
    onResize(event) {
        this.deviceType();
        this.changeDetector.detectChanges();
    }
    deviceType() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.isDesktopDevice = this.deviceService.isDesktop();
    }
    openQRScanner() {
        this.compService.openModal(QrScannerModalComponent, {
            enableScanner: true
        });
    }
    errors() {
        return !!(!this.user || !this.validDepositAddress || this.accountNameEmpty || this.errorMessage);
    }
    validateAddress() {
        if (this.eaccountData.deposit_address !== this.previousAddress) {
            this.errorMessage = '';
        }
        this.previousAddress = this.eaccountData.deposit_address;
        if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
            this.utilityService.validateAddress(this.eaccountData.deposit_address, this.currency, this.ecurrencyChains.length > 1 ? this.addressChain['name'] : null).then(result => {
                this.validDepositAddress = result.validDepositAddress;
            });
        }
        else {
            this.validDepositAddress = true;
        }
    }
    validateAccountName() {
        if (this.eaccountData.reference == '' || this.eaccountData.reference == null) {
            this.accountNameEmpty = true;
        }
        else {
            this.accountNameEmpty = false;
        }
    }
    submit() {
        if (this.eaccountData.reference == '' || this.eaccountData.reference == null) {
            this.accountNameEmpty = true;
            return;
        }
        else {
            this.accountNameEmpty = false;
        }
        this.utilityService.validateAddress(this.eaccountData.deposit_address, this.currency, this.ecurrencyChains.length > 1 ? this.addressChain['name'] : null).then(result => {
            this.validDepositAddress = result.validDepositAddress;
            if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
                this.validDepositAddress = result.validDepositAddress;
            }
            else {
                this.validDepositAddress = true;
            }
            if (this.validDepositAddress) {
                if (this.source === 'exchange') {
                    this.httpClient.post('user/addeaccount', {
                        cryptocurrency: this.currency,
                        address: this.eaccountData.deposit_address,
                        reference: this.eaccountData.reference,
                        chain: this.addressChain['name']
                    }).subscribe((data) => {
                        this.success();
                        this.close();
                        this.compService.openModal(ExchangeAddressConfirmationMailSentComponent);
                    }, error => {
                        if (error.error['message']) {
                            this.errorMessage = error.error['message'];
                        }
                    });
                }
                else {
                    this.httpClient.post('wallet/addnewaddresstowhitelist', {
                        currency: this.currency,
                        newDestinationAddress: this.eaccountData.deposit_address,
                        newDestinationAddressName: this.eaccountData.reference,
                        chain: this.addressChain['name']
                    }).subscribe((data) => {
                        this.success();
                        this.close();
                        this.compService.openModal(WhitelistAddressConfirmationMailSentComponent);
                    }, (error) => {
                        if (error.error['message']) {
                            this.errorMessage = error.error['message'][0];
                        }
                    });
                }
            }
        });
    }
    close() {
        this.modal.destroy();
    }
    setCurrency(currency) {
        this.currency = currency;
        this.getEcurrencyChains();
        if (this.eaccountData.deposit_address) {
            this.validateAddress();
        }
    }
    openSource() {
        this.showSource = !this.showSource;
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (!targetElement.classList.contains('selectOption') &&
            !targetElement.classList.contains('sourceSelected') &&
            !targetElement.classList.contains('sourceSelect')) {
            this.closeSource();
        }
        if (!targetElement.classList.contains('chainOption') &&
            !targetElement.classList.contains('chainSelected') &&
            !targetElement.classList.contains('chainSelect')) {
            this.closeChainsDropdown();
        }
    }
    closeSource() {
        this.showSource = false;
    }
    setSource(item) {
        this.source = item;
        if (this.source === 'exchange') {
            this.ecurrencies = this.exchangeEcurrencies;
            this.numberOfEcurrencies = this.ecurrencies.length;
            this.currency = this.ecurrencies[0].code;
            this.getEcurrencyChains();
        }
        else {
            this.ecurrencies = this.walletEcurrencies;
            this.numberOfEcurrencies = this.ecurrencies.length;
            this.currency = this.ecurrencies[0].verboseId;
            this.getEcurrencyChains();
        }
    }
    openChainsDropdown() {
        this.showChains = !this.showChains;
    }
    setAddressChain(ecurrencyChain) {
        this.addressChain = ecurrencyChain;
        if (this.eaccountData.deposit_address) {
            this.validateAddress();
        }
    }
    closeChainsDropdown() {
        this.showChains = false;
    }
    getEcurrencyChains() {
        this.httpClient.get('market/order/get_ecurrency_chains?currency=' + this.currency).subscribe((result) => {
            this.ecurrencyChains = result['chains'];
            if (this.ecurrencyChains.length === 1) {
                this.addressChain = this.ecurrencyChains[0]['chain'];
            }
            else {
                this.addressChain = this.ecurrencyChains.find(chain => chain.is_default)['chain'];
            }
        });
    }
};
NewEAccountComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: AuthService },
    { type: EcurrenciesService },
    { type: UtilityService },
    { type: QrScannerModalService },
    { type: DeviceDetectorService },
    { type: ChangeDetectorRef },
    { type: WebClientService },
    { type: ComponentService }
];
__decorate([
    Input()
], NewEAccountComponent.prototype, "message", void 0);
__decorate([
    HostListener('window:resize', ['$event'])
], NewEAccountComponent.prototype, "onResize", null);
__decorate([
    HostListener('document:click', ['$event'])
], NewEAccountComponent.prototype, "onDocumentClick", null);
NewEAccountComponent = __decorate([
    Component({
        selector: 'ecd-new-eaccount',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./new-eaccount.component.html")).default
    })
], NewEAccountComponent);
export { NewEAccountComponent };
